import { useMutation, useQueryClient } from "@tanstack/react-query";
import axios from "axios";
import { toast } from "react-toastify";
import http from "../../../utils/http";

type Payload = {
  appointmentId: any;
}

export const useCancelAppointment = () => {
  const queryClient = useQueryClient();
  const { mutate, context, ...rest } = useMutation({
    mutationKey: ['cancel appointment'],
    mutationFn: async ({ appointmentId }: Payload) => {
      const response = await http.delete(`appointments/patient/${appointmentId}`);
      return response.data;
    },
    onMutate: () => {
      const toastId = toast.loading("Please wait...");
      return { toastId };
    },
    onSuccess: (_data, _variables, context) => {
      const { toastId } = context;
      toast.update(toastId, {
        render: "Appointment cancelled successfully",
        type: "success",
        isLoading: false,
        autoClose: 5000,
        closeButton: true,
      })
      queryClient.invalidateQueries({ queryKey: ['provider upcoming appointments', 'get all patient appointments'] as const});
    },

    onError: (error, _variables, context) => {
      const toastId = context?.toastId as number

      if (axios.isAxiosError(error)) {
        toast.update(toastId, {
          render: error?.response?.data?.error || error.response?.statusText,
          type: "error",
          isLoading: false,
          autoClose: 5000,
          closeButton: true,
        })
      } else {
        toast.update(toastId, {
          render: error?.message || "Error cancelling appointment",
          type: "error",
          isLoading: false,
          autoClose: 5000,
          closeButton: true,
        });
      }
    },
  });

  return {
    cancelAppointment: mutate,
    ...rest,
  };
}